import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { LazyLoadScriptService } from './../sidebar/lazy-load-script.service'
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-franchise',
    templateUrl: './franchise.component.html'
})

export class FranchiseComponent implements OnInit {
    imageoneFranchise: boolean = false;
    pageTitle: string;
    pageDisplay: string;

    constructor(
        private activatedroute: ActivatedRoute,
        private router: Router,
        private lazyLoadService: LazyLoadScriptService
    ) { }

    ngOnInit(): void {
        var applicationName = "franchiseappelement";
        
        this.lazyLoadService.loadScript(environment["FRANCHISEAPPURL"], applicationName).subscribe(_ => {
            let url = this.router.url;
            if (url == '/prospect') {
                this.pageTitle = "Prospect List";
                this.pageDisplay = "prospect";
            } else if (url == '/prospect/inactive') {
                this.pageTitle = "Inactive Prospect List";
                this.pageDisplay = "inactiveProspects";
              } 
            else if (url == '/prospect-followups') {
                this.pageTitle = "Prospect Follow Ups";
                this.pageDisplay = "prospectFollowUps";
            } 
            else if (url == '/prospect-appointments') {
                this.pageTitle = "Prospect Appointments";
                this.pageDisplay = "prospectAppointments";
            }
            else if (url == '/prospect/import') {
                this.pageTitle = "Import Prospect";
                this.pageDisplay = "importProspect";
            }
            else if (url == '/prospect/add') {
                this.pageTitle = "New Prospect";
                this.pageDisplay = "prospectNew";
            }
            else if (url.includes('/prospect/edit')) {
                this.pageTitle = "Update Prospect";
                this.pageDisplay = "prospectUpdate";
            }
            else if (url == '/franchise') {
                this.pageTitle = "Franchisee List";
                this.pageDisplay = "franchise";
            }
            else if (url == '/franchise/export') {
                this.pageTitle = "Export Franchise";
                this.pageDisplay = "exportFranchise";
            }
            else if (url == '/franchise/inactive') {
                this.pageTitle = "Inactive Franchisee List";
                this.pageDisplay = "inactiveFranchise";
            }
            else if (url == '/franchise/inactive/export') {
                this.pageTitle = "Export Inactive Franchise";
                this.pageDisplay = "exportInactiveFranchise";
            }
            else if (url == '/franchise/map') {
                this.pageTitle = "Franchise Map";
                this.pageDisplay = "franchiseMap";
            }
            else if (url.includes('/franchise/details')) {
                this.pageTitle = "Franchise Details";
                this.pageDisplay = "franchiseDetails";
            }
            else if (url.includes('/franchise/edit')) {
                this.pageTitle = "Update Franchise";
                this.pageDisplay = "updateFranchise";
            }
            else if (url.includes('/franchise/assignClients')) {
                this.pageTitle = "Assign Service Location to Franchise ";
                this.pageDisplay = "assignClients";
            }
            console.info('Page Display:',this.pageDisplay);
            this.imageoneFranchise = true;
        });

    }

    ngOnDestroy(): void {
        this.imageoneFranchise = false;
    }
}